import React, { useState, useEffect } from "react";
import { Box, Drawer, Typography, Link, Grid, IconButton } from "@mui/material";
import EmailIcon from "@mui/icons-material/EmailOutlined";
import CallIcon from "@mui/icons-material/CallOutlined";
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import CloseIcon from '@mui/icons-material/Close';
import { useTheme } from '@mui/material/styles';
import { GetDrawerWidth, ActionIconStyle } from "../utils/AAStyles";

function AAHelpDrawer(props) {
  const theme = useTheme();

  const [guiVersion, setGuiVersion] = useState(null);
  const [apiVersion, setApiVersion] = useState(null);
  const [isOpen] = useState(props.open);

  useEffect(() => {
      setGuiVersion("0.0");
      setApiVersion("0.0");

      return () => {};
  }, []);

  const SubTitle = (title) =>
  {
    return (
     <Typography align="left" variant="subtitle1" sx={{color: "#797979", fontWeight: 600}}>
      {title}
    </Typography>
  )};

  const BodyText = (text) =>
  {
    return (
     <Typography align="left" variant="body2" sx={{color: "#535353"}}>
      {text}
    </Typography>
  )};

  async function copyTextToClipboard(text) {
    if ('clipboard' in navigator) {
      return await navigator.clipboard.writeText(text);
    } else {
      return document.execCommand('copy', true, text);
    }
  }

  const copyMetadataInfo = (event) => {
    event.stopPropagation();

    let copyString = `Symphony Search Apikey Manager metadata information\n`;
    copyString += `==================================\n`;
    copyString += `\n`;
    copyString += `GUI version: ${guiVersion}\n`;

    copyTextToClipboard(copyString);
  };
 
  
  
  return (
    <Drawer
      sx={{ 
        width: isOpen ? GetDrawerWidth() : 0,
        anchor: "right",
        flexShrink: 0,
        "& .MuiDrawer-paper": {
          width: isOpen ? GetDrawerWidth() : 0,
        },
      }}
      variant="persistent"
      anchor="right"
      open={isOpen}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          padding: theme.spacing(1, 1),
          // necessary for content to be below app bar
          ...theme.mixins.toolbar,
          justifyContent: "flex-start",
        }}
      >
        <Grid container direction="row" justifyContent="space-between" alignItems="center">
          <Grid item>
            <Typography variant="h6" noWrap sx={{ color: "#797979", padding: theme.spacing(1, 1) }}>
              Help and support
            </Typography>
          </Grid>
          <Grid item sx={{padding: theme.spacing(1, 1)}}>
              <IconButton aria-label="Close" onClick={props.handleDrawerClose} size="large"  >
              <CloseIcon variant="close" />
              </IconButton>
          </Grid>
        </Grid>
      </Box>
      <Box>
        <Grid container direction="column" justifyContent="center" alignItems="flex-start" sx={{paddingLeft: theme.spacing(2)}}>
        <Grid item xs={12} sx={{ paddingTop: theme.spacing(2), }}>
            {SubTitle("Symphony Search Apikey Manager")}
          </Grid>
          <Grid item xs={12} sx={{ paddingTop: theme.spacing(1), marginRight:theme.spacing(3) }}>
            {BodyText("Yet another place where nothing has been specified")}
          </Grid>
          <Grid item xs={12} sx={{ paddingTop: theme.spacing(3),paddingBottom: theme.spacing(3), marginRight:theme.spacing(3) }}>
          </Grid>
          <Grid container direction="row" justifyContent="flex-start" alignItems="flex-start" sx={{ paddingTop: theme.spacing(1), }}>
          </Grid>
          <Grid item xs={12} sx={{ paddingTop: theme.spacing(6), }}>
            {SubTitle("General Enquiries")}
          </Grid>
          <Grid container direction="row" justifyContent="flex-start" alignItems="center" sx={{ paddingTop: theme.spacing(1)}}>
            <Grid item xs={1}>
              <EmailIcon sx={{ color: "#535353", display: "inline-flex"}} />
            </Grid>
            <Grid item sx={{ display: "inline-flex"}}>
              <Link align={"left"}
                href="mailto:solutions@aligned-assets.co.uk?subject=Solutions enquiry raised from Symphony Search Apikey Manager"
                variant="body2"
              >
                solutions@aligned-assets.co.uk
              </Link>
            </Grid>
          </Grid>
          <Grid container direction="row" justifyContent="flex-start" alignItems="center">
            <Grid item xs={1}>
              <CallIcon sx={{ color: "#535353", display: "inline-flex" }}/>
            </Grid>
            <Grid item>
              {BodyText("+44 (0) 1483 717 950")}
            </Grid>
          </Grid>
          <Grid item xs={12} sx={{ paddingTop: theme.spacing(1) }}>
            {BodyText("Idox Group")}
            {BodyText("Unit 5 Woking 8")}
            {BodyText("Forsyth Road")}
            {BodyText("Woking")}
            {BodyText("Surrey")}
            {BodyText("GU21 5SB")}
          </Grid>
          <Grid item xs={12}  sx={{paddingTop: theme.spacing(2)}}>
            {SubTitle("Metadata information")}
          </Grid>
          <Grid container direction="row" justifyContent="flex-start" alignItems="center">
            <Grid item xs={12}>
              {BodyText(`GUI version: ${guiVersion}`)}
            </Grid>
            <Grid item xs={1}>
              <IconButton onClick={(event) => copyMetadataInfo(event)} size="small">
                <ContentCopyIcon sx={ActionIconStyle()} />
              </IconButton>
            </Grid>
            <Grid
              item
              sx={{
                display: "inline-flex",
              }}
            >
              <Link component="button" align={"left"} variant="body2" onClick={(event) => copyMetadataInfo(event)}>
                Copy metadata information
              </Link>
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </Drawer>
  );
}

export default AAHelpDrawer;
